var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import NavBar from "../../organisms/navBar/navBar";
import "../../templates/general_page_template.css";
import Card from "../../atoms/card/card";
import "../../styles/text.css";
import "./faq.css";
import faq from "./jobSeekerHelpAndSupport.json";
import PageHeader from "../../organisms/pageHeader/pageHeader";
import { useSelector } from "react-redux";
export default function JobSeekerHelpAndSupport() {
    var _a = useState(null), openIndex = _a[0], setOpenIndex = _a[1];
    var handleToggle = function (index) {
        setOpenIndex(openIndex === index ? null : index);
    };
    var data = [];
    var _loop_1 = function (i) {
        data.push(_jsxs("div", __assign({ className: "my-2 border-b border-gray-200" }, { children: [_jsxs("button", __assign({ className: "w-full text-left py-3 px-2 font-semibold text-text focus:outline-none flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors", onClick: function () { return handleToggle(i); }, "aria-expanded": openIndex === i }, { children: [_jsx("span", { children: faq[i].question }), _jsx("span", __assign({ className: "ml-2" }, { children: openIndex === i ? "▲" : "▼" }))] })), openIndex === i && (_jsx("div", __assign({ className: "px-4 py-2 text-text bg-white animate-fade-in" }, { children: faq[i].answer })))] }), i));
    };
    for (var i = 0; i < faq.length; i++) {
        _loop_1(i);
    }
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    var viewing_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_user_type; });
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    return (_jsxs("div", __assign({ className: "h-full" }, { children: [_jsx(NavBar, { viewing_user: viewing_user_type, logged_in_user: logged_in_user_type, viewing_username: viewing_username }), _jsxs("div", __assign({ className: "page-template-right" }, { children: [_jsx(PageHeader, { title: "Help & Support" }), _jsxs(Card, __assign({ scrollable: true, multiLine: true }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("p", __assign({ className: "text-title" }, { children: "FAQ" })), _jsx("p", __assign({ className: "text-subtitle" }, { children: "Effective Date 20 Jan 2024" }))] })), data] }))] }))] })));
}
